// @flow
import React, {Component} from 'react';
import {StyleSheet, Image, View} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import InstallEsimButton from './InstallEsimButton';
import {GradientPage, TertiaryFullButton} from '../common';
import theme from '../../theme-config';
import I18n from '../../lib/i18n';

class FinalPage extends Component<Props> {
  styles = getStyles();

  onPress = () => {
    if (this.props.hasError && this.props.onRetry) {
      this.props.onRetry();
    } else if (!this.props.hasError) {
      this.props.goToDashboard();
    }
  };

  onPressInstallESim = () => {
    if (!this.props.hasError && this.props.installESim) {
      this.props.installESim();
    }
  };

  render() {
    const styles = this.styles;
    return (
      <GradientPage backgroundImage={theme.upDownStrokesBackgroundImage} iosEdges={['top','bottom']}>
        <View style={styles.container} testID="congrats-screen">
          <Image style={this.props.imageStyle} source={this.props.image} />
          <View style={styles.textContainer}>
            {this.props.title && (
              <Text style={styles.text} testID={'congratsTitle'}>
                {this.props.title}
              </Text>
            )}
            <Text style={styles.text}>{this.props.text}</Text>
          </View>
        </View>
        {!this.props.hasError && this.props.eSimSelected && (
          <InstallEsimButton
            installEsimText={I18n.t('SignUp.FinalPage.installEsim')}
            installEsimAction={this.onPressInstallESim}
            goToMailBoxText={I18n.t('SignUp.FinalPage.goToMailbox')}
          />
        )}
        <TertiaryFullButton
          style={styles.goToDashboard}
          onPress={this.onPress}
          text={
            this.props.hasError
              ? I18n.t('SignUp.FinalPage.retry')
              : I18n.t('SignUp.FinalPage.goToDashboard')
          }
          isLoading={this.props.isLoading}
          testID={'goToDashboardButton'}
          isNotLoadingTestID={'isNotLoadingGoToDashboardButton'}
        />
      </GradientPage>
    );
  }
}

function getStyles() {
  return StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    text: {
      backgroundColor: 'transparent',
      color: theme.signUpTextColor,
      fontSize: 18,
      textAlign: 'center',
    },
    textContainer: {
      marginVertical: 70,
      paddingHorizontal: 20,
      alignItems: 'center',
    },
    loader: {
      marginTop: 20,
    },
    goToDashboard: {
      marginBottom: 20,
      marginHorizontal: 20,
    },
    installEsim: {
      marginBottom: 20,
      marginHorizontal: 20,
      fontSize: 14,
    },
  });
}

type Props = {
  text: string,
  title: string,
  image: number,
  imageStyle: ImageStyle,
  isLoading?: boolean,
  hasError: boolean,
  eSimSelected: boolean,
  onRetry?: Function,
  goToDashboard: Function,
  installESim: Function,
};

type ImageStyle = {|
  height: number,
  resizeMode: 'contain' | 'cover' | 'stretch' | 'center' | 'repeat',
  width: number,
|};

export default FinalPage;
